import { useTheme } from "@emotion/react";
import React from "react";

const HighlightedText = ({ text, highlight }) => {
  const theme= useTheme();
  const getHighlightedText = (text, highlight) => {
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} style={{ color: theme.palette.primary.main}}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  return (
    <p style={{ padding: "0", margin: "0" }}>
      {getHighlightedText(text, highlight)}
    </p>
  );
};

export default HighlightedText;
